import { createContext } from 'react';

import { captureException } from '@sentry/react';

import { useAuthContext } from '@cognite/e2e-auth';
import type { CogniteClient } from '@cognite/sdk';

import { useInFieldMetrics } from '../../../../hooks/use-infield-metrics';
import { createInfieldAppConfigService } from '../../cdm-infield-app-config.service';

export interface UseGetAllInfieldLocationsContextInterface {
  captureException: typeof captureException;
  useAuthContext: () => {
    client: {
      instances: Pick<CogniteClient['instances'], 'list'>;
    };
  };
  createInfieldAppConfigService: typeof createInfieldAppConfigService;
  useInFieldMetrics: typeof useInFieldMetrics;
}

const defaultValue: UseGetAllInfieldLocationsContextInterface = {
  captureException,
  useAuthContext,
  createInfieldAppConfigService,
  useInFieldMetrics,
};

export const UseGetAllInfieldLocationsContext =
  createContext<UseGetAllInfieldLocationsContextInterface>(defaultValue);
